/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraBase64URLGuard,
  GamoraFoundationGuard,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakDataType } from '../../data.js';

/**
 * Input type
 * @public
 */
export interface HoruzProtocolChulakMessageGuardInput {}

/**
 * @public
 */
export abstract class HoruzProtocolChulakMessageGuard<
  TType extends HoruzProtocolChulakDataType,
  TInput extends HoruzProtocolChulakMessageGuardInput =
    HoruzProtocolChulakMessageGuardInput,
> extends GamoraFoundationGuard<TInput> {
  abstract type: TType;

  /**
   * Create clone
   */
  abstract override clone(
    options?: any,
  ): HoruzProtocolChulakMessageGuard<TType, TInput>;

  /**
   * To Base64URL
   */
  override toBase64URL(): string {
    const json = this.toJSON();
    return GamoraBase64URLGuard.fromUTF8(JSON.stringify(json)).toBase64URL();
  }
}
